module.exports = __webpack_public_path__ + "media/palenque/kid-266dcd85.jpg";